import { Component, Input, OnInit } from '@angular/core';
import { WeatherInterface } from '@app/app/shared/interfaces/weather.interface';
import { environment } from '@app/environments/environment';
import { WeatherService } from '@app/app/shared/services/weather.service';
import { ParkLocationInterface } from '@app/app/shared/interfaces/park-location.interface';

@Component({
  templateUrl: './park-weather.html',
  selector: 'park-weather'
})
export class ParkWeatherComponent implements OnInit {
  @Input() location: ParkLocationInterface;
  public weather: WeatherInterface;
  public iconsUrl = environment.weather.iconsUrl;

  constructor(private weatherService: WeatherService) {
  }

  ngOnInit() {
    this.weatherService.fetchByCoords(this.location).subscribe(data => this.weather = data);
  }
}



// WEBPACK FOOTER //
// ./src/app/dashboard/parks/park/weather/park-weather.component.ts